const LightTheme = {
  "--b1": "#ffffff",
  "--b2": "#e8e8e8",
  "--b3": "#dedede",
  "--f1": "#000000",
  "--s1": "#007AA6"
};

export default LightTheme;
